import { render, staticRenderFns } from "./LeftNovaUnimed.vue?vue&type=template&id=a5fb7d26"
import script from "./LeftNovaUnimed.vue?vue&type=script&lang=js"
export * from "./LeftNovaUnimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports